import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { BlacklistMutationKeys } from '../../../keys'
import {
	CreateBlacklistReportRequest,
	CreateBlacklistReportResponse,
} from '../../../type'
import { createBlacklistReport } from '../../services'

export default function useMutationCreateBlacklistReport(
	props?: UseBaseMutationOptions<
		CreateBlacklistReportResponse,
		CreateBlacklistReportRequest
	>,
) {
	return useMutation({
		mutationKey: [BlacklistMutationKeys.CreateBlacklistReport],
		mutationFn: (params) => createBlacklistReport(params),
		...props,
	})
}
